import React from 'react'

const MyFiles = () => {
  return (
    <div>MyFiles</div>
  )
}

export default MyFiles